import React from "react"

const LinkedInIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="white" />
      <path
        d="M18.5811 20.8984H14.4512V34.0686H18.5811V20.8984Z"
        fill="#111A2F"
      />
      <path
        d="M29.7528 20.6131C29.6005 20.5941 29.4388 20.5845 29.277 20.575C26.9646 20.4799 25.6609 21.8502 25.2042 22.4402C25.0805 22.6019 25.0234 22.6971 25.0234 22.6971V20.9366H21.0742V34.1068H25.0234H25.2042C25.2042 32.765 25.2042 31.4328 25.2042 30.091C25.2042 29.3678 25.2042 28.6446 25.2042 27.9214C25.2042 27.0269 25.1376 26.0753 25.5848 25.2569C25.9654 24.5717 26.6506 24.2292 27.4214 24.2292C29.7052 24.2292 29.7528 26.2941 29.7528 26.4845C29.7528 26.494 29.7528 26.5035 29.7528 26.5035V34.1639H33.8827V25.5709C33.8827 22.6305 32.3887 20.8986 29.7528 20.6131Z"
        fill="#111A2F"
      />
      <path
        d="M16.5152 19.1955C17.8396 19.1955 18.9133 18.1218 18.9133 16.7974C18.9133 15.473 17.8396 14.3994 16.5152 14.3994C15.1908 14.3994 14.1172 15.473 14.1172 16.7974C14.1172 18.1218 15.1908 19.1955 16.5152 19.1955Z"
        fill="#111A2F"
      />
    </svg>
  )
}

export default LinkedInIcon
